import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";

export const useSearchPageFormattedTotalPrimaryResultsCount = () => {
  const {
    data: { totalPrimaryResultsCountFormatted },
  } = useFilterStore(["totalPrimaryResultsCountFormatted"]);
  return totalPrimaryResultsCountFormatted ?? "";
};
